import taskTypesModule from "./legacy/task-types/task-types.module";
import createSessionModule from "./v4/create-session/create-session.module";
import createSignupCodeModule from "./v4/create-signup-code/create-signup-code.module";
import postFileModule from "./v4/file/post/post-file.module";
import requestModule from "./v4/get-requests/get-requests.module";
import getV4TaskTypesModule from "./v4/get-task-types/get-task-types.module";
import volunteerGroupModule from "./v4/get-volunteer-group/volunteer-group.module";
import createOrganisationModule from "./v4/organisation/organisations.module";
import patchRequestModule from "./v4/post-patch-request/post-patch-request.module";
import signUpCodesModule from "./v4/signup-codes/signup-codes.module";
import signUpCodesDetailsModule from "./v4/signup-codes-details/signup-codes-details.module";
import usersModule from "./v4/user/user.module";
import deleteCampaignModule from "./v5/campaign/delete/delete-campaign.module";
import getCampaignModule from "./v5/campaign/get/get-campaign.module";
import campaignDeletePermissionsModule from "./v5/campaign/permission-assignments/delete/delete-permission-assignments.module";
import postCampaignPermissionsModule from "./v5/campaign/permission-assignments/post/post-permission-assignments.module";
import postCampaignModule from "./v5/campaign/post/post-campaign.module";
import deleteRequestFilterSetsModule from "./v5/request-filter-sets/delete/delete-request-filter-sets.module";
import getRequestFilterSetsModule from "./v5/request-filter-sets/get/get-request-filter-sets.module";
import patchRequestFilterSetsModule from "./v5/request-filter-sets/patch/patch-request-filter-sets.module";
import requestFilterDeletePermissionsModule from "./v5/request-filter-sets/permission-assignments/delete/delete-permission-assignments.module";
import requestFilterSetPermissionsModule from "./v5/request-filter-sets/permission-assignments/post/post-permission-assignments.module";
import postRequestFilterSetsModule from "./v5/request-filter-sets/post/post-request-filter-sets.module";

const createSession = createSessionModule();
const signUpCodes = signUpCodesModule();
const signUpCodesDetails = signUpCodesDetailsModule();
const createSignupCode = createSignupCodeModule();
const volunteerGroup = volunteerGroupModule();
const requests = requestModule();
const patchRequest = patchRequestModule();
const taskTypes = taskTypesModule();
const getV4TaskTypes = getV4TaskTypesModule();
const getRequestFilterSets = getRequestFilterSetsModule();
const patchRequestFilterSets = patchRequestFilterSetsModule();
const postRequestFilterSets = postRequestFilterSetsModule();
const deleteRequestFilterSets = deleteRequestFilterSetsModule();
const requestFilterSetPermissions = requestFilterSetPermissionsModule();
const requestFilterDeletePermissions = requestFilterDeletePermissionsModule();
const users = usersModule();
const postFile = postFileModule();
const createOrganisation = createOrganisationModule();
const getCampaign = getCampaignModule();
const postCampaign = postCampaignModule();
const deleteCampaign = deleteCampaignModule();
const deleteCampaignPermission = campaignDeletePermissionsModule();
const postCampaignPermission = postCampaignPermissionsModule();

export {
	createOrganisation,
	createSession,
	createSignupCode,
	deleteCampaign,
	deleteCampaignPermission,
	deleteRequestFilterSets,
	getCampaign,
	getRequestFilterSets,
	getV4TaskTypes,
	patchRequest,
	patchRequestFilterSets,
	postCampaign,
	postCampaignPermission,
	postFile,
	postRequestFilterSets,
	requestFilterDeletePermissions,
	requestFilterSetPermissions,
	requests,
	signUpCodes,
	signUpCodesDetails,
	taskTypes,
	users,
	volunteerGroup,
};
